import { render, staticRenderFns } from "./HelpUs.vue?vue&type=template&id=720155bc&scoped=true&"
import script from "./HelpUs.vue?vue&type=script&lang=js&"
export * from "./HelpUs.vue?vue&type=script&lang=js&"
import style0 from "./HelpUs.vue?vue&type=style&index=0&id=720155bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720155bc",
  null
  
)

export default component.exports